export class DeleteClientUserReqData {
    name: string;

    constructor(name: string) {
        this.name = name;
    }
}
